import React from 'react';

interface KPICardProps {
  title: string;
  value: string | number;
  subtext?: string;
  subtextColor?: 'green' | 'red' | 'amber' | 'default';
  bgColor?: string;
  icon?: React.ReactNode;
  loading?: boolean;
  border?: boolean;
}

const subtextColorClass: Record<string, string> = {
  green: 'text-success',
  red: 'text-danger',
  amber: 'text-warning',
  default: 'text-text-secondary',
};

export default function KPICard({
  title,
  value,
  subtext,
  subtextColor = 'default',
  bgColor = 'bg-bg-tertiary',
  icon,
  loading = false,
  border = true,
}: KPICardProps) {
  if (loading) {
    return (
      <div className={`${bgColor} rounded-card p-4 flex-1 min-w-0 ${border ? 'border border-border' : ''} shadow-card`}>
        <div className="shimmer h-3 w-24 rounded mb-3" />
        <div className="shimmer h-6 w-20 rounded mb-2" />
        <div className="shimmer h-3 w-32 rounded" />
      </div>
    );
  }

  return (
    <div className={`${bgColor} rounded-card p-4 flex-1 min-w-0 ${border ? 'border border-border' : ''} shadow-card`}>
      <div className="flex items-start justify-between mb-1">
        <p className="text-xs text-text-secondary font-medium uppercase tracking-wide leading-tight">{title}</p>
        {icon && <span className="text-text-tertiary ml-2 flex-shrink-0">{icon}</span>}
      </div>
      <p className="text-xl font-bold text-text-primary leading-tight mt-1">{value}</p>
      {subtext && (
        <p className={`text-xs mt-1 ${subtextColorClass[subtextColor]}`}>{subtext}</p>
      )}
    </div>
  );
}
